import { Box } from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Container = styled(Box)`
  &.MuiBox-root {
    background: ${colorTokens.background.light};
    display: flex;
    align-items: center;
    flex-direction: column;

    height: calc(100vh);
    padding-top: 80px;
  }
`;
